import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/GetHistogramConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var moment = require('moment');
var _ = require("lodash");
var organization, country, locality, area, profileId, granularity = 'weekly';
var dateRange = {}, filters = {};

var DatewiseInsightHistoAction = function () {

}


DatewiseInsightHistoAction.prototype = {

	clearFilters: function () {
		filters = {};
		organization = "";
		country = undefined;
		locality = undefined;
		area = undefined;
		granularity = 'weekly';
	},

	addDownloadFilters: function (data) {
		filters = _.cloneDeep(data);
		if (filters.profileId) {
			profileId = filters.profileId;
			delete filters.profileId
		}
		if (data.granularity) {
			granularity = "weekly";
			// delete data.granularity;
		}
		this.loadData();
	},

	addFilters: function (data, newGranularity) {
		filters = data;
		granularity = newGranularity;
		this.loadData();
	},

	changeProfile: function (value) {
		profileId = value;
		this.loadData();
	},

	// clearFilters: function () {
	// 	organization = "";
	// 	country = undefined;
	// 	locality = undefined;
	// 	area = undefined;
	// 	granularity = 'weekly';
	// },

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData()
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData();
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
	},

	changeGranularity: function (value) {
		granularity = value;
		this.loadData();
	},

	loadData: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		filters['insightFilters'] = {
			"metrics": [
				"ACTIONS_DRIVING_DIRECTIONS",
				"ACTIONS_PHONE",
				"ACTIONS_WEBSITE"
			]
		}
		var data = {
			profileId: localStorage.getItem('profileId'),
			"granularity": "weekly",
			"graphType": ["dayOfWeek"],
			filters: filters
		};


		restClient.getLocationInsightHistogram(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.DATEWISE_INSIGHT_HISTO_PHONE,
					data: response
				});
			}
		})
	},
}

export default new DatewiseInsightHistoAction();
